

export const getPercent = (value:number, total:number) => {
  
  const percent = ( Number(value) / Number(total)) * 100

  return percent;
}
